export const GET_COUNTER_INFO = "GET_COUNTER_INFO";
export const GET_COUNTER_INFO_SUCCESS = "GET_COUNTER_INFO_SUCCESS";
export const GET_COUNTER_INFO_ERROR = "GET_COUNTER_INFO_ERROR";

export const GET_CONTENT_CONFIG = "GET_CONTENT_CONFIG";
export const GET_CONTENT_CONFIG_SUCCESS = "GET_CONTENT_CONFIG_SUCCESS";
export const GET_CONTENT_CONFIG_ERROR = "GET_CONTENT_CONFIG_ERROR";

export const GET_CREDIT_MONTHS = "GET_CREDIT_MONTHS";
export const GET_CREDIT_MONTHS_SUCCESS = "GET_CREDIT_MONTHS_SUCCESS";
export const GET_CREDIT_MONTHS_ERROR = "GET_CREDIT_MONTHS_ERROR";

export const SET_PREPARED_CREDITS = "SET_PREPARED_CREDITS";
export const REMOVE_PREPARED_CREDITS = "REMOVE_PREPARED_CREDITS";

export const GET_CREDITS = "GET_CREDITS";
export const GET_CREDITS_SUCCESS = "GET_CREDITS_SUCCESS";
export const GET_CREDITS_ERROR = "GET_CREDITS_ERROR";

export const GET_CLAIMED_CONTENT = "GET_CLAIMED_CONTENT";
export const GET_CLAIMED_CONTENT_SUCCESS = "GET_CLAIMED_CONTENT_SUCCESS";
export const GET_CLAIMED_CONTENT_ERROR = "GET_CLAIMED_CONTENT_ERROR";

export const SAVE_CREDITS = "SAVE_CREDITS";
export const SAVE_CREDITS_SUCCESS = "SAVE_CREDITS_SUCCESS";
export const SAVE_CREDITS_ERROR = "SAVE_CREDITS_ERROR";

export const GET_QUESTIONNAIRE_QUESTIONS = "GET_QUESTIONNAIRE_QUESTIONS";
export const GET_QUESTIONNAIRE_QUESTIONS_SUCCESS =
  "GET_QUESTIONNAIRE_QUESTIONS_SUCCESS";
export const GET_QUESTIONNAIRE_QUESTIONS_ERROR =
  "GET_QUESTIONNAIRE_QUESTIONS_ERROR";

export const GET_QUESTIONNAIRE_ANSWERS = "GET_QUESTIONNAIRE_ANSWERS";
export const GET_QUESTIONNAIRE_ANSWERS_SUCCESS =
  "GET_QUESTIONNAIRE_ANSWERS_SUCCESS";
export const GET_QUESTIONNAIRE_ANSWERS_ERROR =
  "GET_QUESTIONNAIRE_ANSWERS_ERROR";

export const SAVE_QUESTIONNAIRE_ANSWERS = "SAVE_QUESTIONNAIRE_ANSWERS";
export const SAVE_QUESTIONNAIRE_ANSWERS_SUCCESS =
  "SAVE_QUESTIONNAIRE_ANSWERS_SUCCESS";
export const SAVE_QUESTIONNAIRE_ANSWERS_ERROR =
  "SAVE_QUESTIONNAIRE_ANSWERS_ERROR";

export const ADD_SELECTED_CREDITS = "ADD_SELECTED_CREDITS";
export const REMOVE_SELECTED_CREDITS = "REMOVE_SELECTED_CREDITS";

export const SHOW_GLOBAL_SPINNER = "SHOW_GLOBAL_SPINNER";
export const HIDE_GLOBAL_SPINNER = "HIDE_GLOBAL_SPINNER";

export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_ERROR = "GET_SETTINGS_ERROR";

export const SAVE_SETTINGS = "SAVE_SETTINGS";
export const SAVE_SETTINGS_SUCCESS = "SAVE_SETTINGS_SUCCESS";
export const SAVE_SETTINGS_ERROR = "SAVE_SETTINGS_ERROR";

export const SHOW_SETTINGS_MODAL = "SHOW_SETTINGS_MODAL";
export const HIDE_SETTINGS_MODAL = "HIDE_SETTINGS_MODAL";

export const GET_CLAIMS = "GET_CLAIMS";
export const GET_CLAIMS_SUCCESS = "GET_CLAIMS_SUCCESS";
export const GET_CLAIMS_ERROR = "GET_CLAIMS_ERROR";

export const SAVE_CLAIMS = "SAVE_CLAIMS";
export const SAVE_CLAIMS_SUCCESS = "SAVE_CLAIMS_SUCCESS";
export const SAVE_CLAIMS_ERROR = "SAVE_CLAIMS_ERROR";

export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const GET_USER_INFO_ERROR = "GET_USER_INFO_ERROR";

export const SHOW_TOAST = "SHOW_TOAST";
export const HIDE_TOAST = "HIDE_TOAST";

export const SETTINGS_MODAL_ACTIVE_TAB = "SETTINGS_MODAL_ACTIVE_TAB";

export const GET_HOWE_WIDGET_INFO_SUCCESS = "GET_HOWE_WIDGET_INFO_SUCCESS";
export const GET_HOWE_WIDGET_INFO_ERROR = "GET_HOWE_WIDGET_INFO_ERROR";

export const GET_CME_BUTTON_INFO_SUCCESS = "GET_CME_BUTTON_INFO_SUCCESS";
export const GET_CME_BUTTON_INFO_ERROR = "GET_CME_BUTTON_INFO_ERROR";
